import { Suspense, lazy } from 'react';

import { DynamicBaseBreadcrumb, DynamicHostingsBreadcrumb } from '../../modules/AppBreadcrumb';
import { Spinner } from '../components';
import { AppControllerType, AppRoutes } from '../interfaces/router';

const HostingsListPage = lazy(() => import('../../pages/Hostings/HostingsList.page'));
const HostingsCreatePage = lazy(() => import('../../pages/Hostings/HostingsCreate.page'));
const HostingsPage = lazy(() => import('../../pages/Hostings/Hostings.page'));

export const HostingsController: AppControllerType = {
  common: [
    {
      path: AppRoutes.Hostings + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <HostingsListPage/>
        </Suspense>
      ),
      breadcrumb: DynamicHostingsBreadcrumb.DynamicHostingsListBreadcrumb
    }
  ],
  drawer: [
    {
      path: AppRoutes.HostingsCreate + '/*',
      element: (
        <Suspense fallback={ <Spinner/> }>
          <HostingsCreatePage/>
        </Suspense>
      ),
      breadcrumb: DynamicBaseBreadcrumb.DynamicBaseCreateBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    },
    {
      path: AppRoutes.HostingsById,
      element: (
        <Suspense fallback={ <Spinner/> }>
          <HostingsPage/>
        </Suspense>
      ),
      breadcrumb: DynamicHostingsBreadcrumb.DynamicHostingsByIdBreadcrumb,
      props: {
        commonDrawerWidth: 460
      }
    }
  ]
};
